import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
import { productRulesFilters } from './credit-product-rules.filters';

export const productRulesSearch = listSearchSchema({
  sheet: z.string().optional().catch(undefined),
  ...productRulesFilters.shape,
});

/** Gavetas da regra na URL (U26): seletor de tipo e a regra aberta (`?sheet=regra&tipo=5`). */
export const productRuleDetailSearch = z.object({
  sheet: z.string().optional().catch(undefined),
  tipo: z.coerce.number().int().optional().catch(undefined),
});

/**
 * `?ruleType=1` decide o id do fio (RulesProductListContainer.tsx:25-26). Número, para a URL sair sem
 * aspas como no legado; o link antigo do novo (`%221%22`, texto) também vira `1`.
 */
export const ruleProductsSearch = listSearchSchema({
  sheet: z.string().optional().catch(undefined),
  ruleType: z.coerce.number().int().optional().catch(undefined),
});
